import Gallery from './extenders/Gallery';
export default [new Gallery('flarum/forum/components/CommentPost', '.Post-body')];